// @flow
import React from 'react'
import styled from 'styled-components'
import media from '../../styles/media'

const Component = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('/static/images/welcome-mat.jpg');
  background-size: cover;
  background-position: center;
  padding: 100px 0;
  position: relative;

  ${media.mdUp} {
    height: calc(100vh - 50px);
  }

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: '';
    background: rgba(0, 0, 0, 0.3);
  }
`

const AuthBackground = ({ children }: { children?: any }) => (
  <Component>{children}</Component>
)

export default AuthBackground



// WEBPACK FOOTER //
// ./src/components/AuthBackground/index.js